import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { Heading } from '../../ui-components/heading/heading';
import { Text } from '../../ui-components/text/text';
import { Button } from '../../ui-components/button/button';
import theme from '../../style/theme';
import { PurchaseButton } from './product-types';

type ProductHeaderProps = {
    productTitle: string;
    shortDescription: string;
    purchaseButton: PurchaseButton;
};

export const ProductHeader = (props: ProductHeaderProps) => {
    const { viewport, siteInfo } = useContext(AppContext);

    return (
        <div class="flex flex-col gap-cvi-4">
            <Heading variant='heading-3xl' tag={'h1'} class="text-pretty">{props.productTitle}</Heading>
            <div>
                <Text fontSize="body-lg" splitParagraph={true}>
                    {props.shortDescription}
                </Text>
            </div>
            <Show when={viewport.width > theme.breakpoints.MOBILE && props.purchaseButton && (siteInfo.siteType === 'default')}>
                <Button label={props.purchaseButton.title} isLink={true} url={props.purchaseButton.url} target={props.purchaseButton.target} />
            </Show>
        </div>
    );
};
